import { Box, CircularProgress } from "@mui/material";

const LoadingIndicator = ({ position = "absolute" }: { position?: "absolute" | "relative" }) => {
  return (
    <Box
      sx={{
        position,
        backgroundColor: "rgba(255,255,255, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        zIndex: 100,
      }}
      data-testid="loading-indicator"
    >
      <CircularProgress title="Loading..." />
    </Box>
  );
};

export default LoadingIndicator;
